import React from 'react'

export const Container1 = () => {
  return (
    <div className="flex-1 p-4 text-center">
    <div className="mt-2 para-headers font-bold text-2xl">
        BRAND AIMS & VALUES
        <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
    </div>
    <div className="block bg-white overflow-hidden border-black border-4 rounded-md hover:text-white hover:bg-black h-2/3">
        <div className="p-4 text-center">
            <div className="mb-4 flex flex-wrap">
            <ul className='ml-4 list-disc inline-block text-left font-text flex-1 font-bold text-sm mobile:text-base tablet:text-lg laptop:text-xl space-y-3 desktop:space-y-2 max-mobile:my-10 laptop:my-10 desktop:my-0 large:my-5'>
                <li> EDUCATING</li>
                <li>ACTIVISM - A PLATFORM TO UNITE WOMEN</li>
                <li>ENVIRONMENTAL AWARENESS & PRODUCT QUALITY</li>
                <li>SOCIAL SUSTAINABILITY</li>
            </ul>
            </div>
        </div>
    </div>
    </div>
  )
}
export const Container2 = () => {
  return (
    <div className="flex-1 p-4 text-center">
    <div className="mt-2 para-headers font-bold text-2xl tablet:pb-[1px]">
        WE ARE STRONGER TOGETHER - CREATIVE COLLABORATION
        <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
    </div>
    <div className="block bg-white overflow-hidden border-black border-4 rounded-md hover:text-white hover:bg-black h-2/3">
        <div className="p-4">
            <div className="mb-4 flex flex-wrap desktop:pb-[70px]">
                <p className='font-text para-text laptop:text-xl my-10 navBM:my-14 navM:my-9 tablet:my-20 desktop:-mb-7'>At ATHENA MERCURY we work alongside like-minded artists to creatively express our views as women living in an archaic society.</p>
            </div>
        </div>
    </div>
    </div>
  )
}
export const Container3 = () => {
  return (
    <div className="flex flex-col items-center justify-center tablet:flex-1 p-4 text-center">
    <div className="mt-2 mb-2 para-headers font-bold text-2xl tablet:pb-9 laptop:pb-0 desktop:pb-9 xlarge:pb-1">
        CONTRIBUTIONS TO THE CAUSE
        <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 tablet:mb-14 desktop:mb-[5rem] xlarge:mb-[7rem]'/>
    </div>
    <div className="block bg-white overflow-hidden h-2/3 border-black border-4 rounded-md hover:text-white hover:bg-black">
        <div className="p-4 ">
            <div className="mb-4 flex flex-wrap ">
                <p className='font-text para-text my-28 navM:my-16 tablet:my-[5rem] laptop:my-[3.2rem] desktop:my-16 large:my-16 max-w-[18rem]'>In collaboration with artist <a href="https://www.instagram.com/thecheckerwoman/" target="_blank" className="hover:text-cmyk font-bold underline hover:no-underline">CHECKERWOMAN</a>, we create empowering female art and clear evidence of the amount and destination of your donations. Allowing full transparency.</p>
            </div>
        </div>
    </div>
    </div>
  )
}
export const Container4 = () => {
  return (
    <div className="flex flex-col items-center justify-center tablet:flex-1 p-4 text-center">
    <div className="mt-2 mb-2 para-headers font-bold text-2xl">
        NOTES OF COMPASSION - BASQUE IN YOUR STRENGTHS
        <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-20'/>
    </div>
    <div className="block bg-white overflow-hidden border-black border-4 rounded-md hover:text-white hover:bg-black h-2/3">
        <div className="p-4">
            <div className="mb-4 flex flex-wrap">
            <p className='font-text para-text mx-2 desktop:my-3 max-w-[18rem]'>In collaborating with artist CHECKERWOMAN, we create one-of-a-kind accessories, displaying a mix of feminist literature and art. Sharing power, love, and knowledge between women, helping us become the best versions of ourselves, never denying ourselves the self-love we all deserve.</p>
            </div>
        </div>
    </div>
    </div>
  )
}
